import { apiClient } from '@/services/ApiClient.js'

export default {
  getOrders(query) {
    return apiClient
      .get('orders', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrder(orderId, query = null) {
    return apiClient
      .get('orders/' + orderId, {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrderPaymentReminders(orderId) {
    return apiClient
      .get('orders/' + orderId + '/payment-reminders')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getInvoice(orderId) {
    return apiClient
      .get('orders/' + orderId + '/invoice', {
        'axios-retry': {
          retries: 5,
          retryDelay: retryCount => {
            return retryCount * 1000
          }
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPromissoryNote(orderId) {
    return apiClient
      .get('orders/' + orderId + '/promissory-note', {
        'axios-retry': {
          retries: 5,
          retryDelay: retryCount => {
            return retryCount * 1000
          }
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSalesContract(orderId) {
    return apiClient
      .get('orders/' + orderId + '/sales-contract', {
        'axios-retry': {
          retries: 5,
          retryDelay: retryCount => {
            return retryCount * 1000
          }
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getTransportationDocument(orderId) {
    return apiClient
      .get('orders/' + orderId + '/transportation-document', {
        'axios-retry': {
          retries: 5,
          retryDelay: retryCount => {
            return retryCount * 1000
          }
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRepaymentSchedule(orderId) {
    return apiClient
      .get('orders/' + orderId + '/repayment-schedule', {
        'axios-retry': {
          retries: 5,
          retryDelay: retryCount => {
            return retryCount * 1000
          }
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getCreditAgreement(orderId) {
    return apiClient
      .get('orders/' + orderId + '/credit-agreement', {
        'axios-retry': {
          retries: 5,
          retryDelay: retryCount => {
            return retryCount * 1000
          }
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrderReceipt(orderId) {
    return apiClient
      .get('orders/' + orderId + '/order-receipt', {
        'axios-retry': {
          retries: 5,
          retryDelay: retryCount => {
            return retryCount * 1000
          }
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFibabankaDocument(orderId, documentType) {
    return apiClient
      .get(`orders/${orderId}/fibabanka-documents/${documentType}`, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getScannedPromissoryNoteVersions(orderId) {
    return apiClient
      .get('orders/' + orderId + '/public-scanned-promissory-note/versions')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getApplicableCrops() {
    return apiClient
      .get('orders/applicable-crops')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  generatePaymentOrderPdf(orderId) {
    return apiClient
      .get('orders/' + orderId + '/payment-order', {
        responseType: 'blob'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        if (
          err.request.responseType === 'blob' &&
          err.response.data instanceof Blob &&
          err.response.data.type &&
          err.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
          return new Promise((resolve, reject) => {
            let reader = new FileReader()
            reader.onload = () => {
              err.response.data = JSON.parse(reader.result)
              resolve(Promise.reject(err))
            }

            reader.onerror = () => {
              reject(err)
            }

            reader.readAsText(err.response.data)
          })
        }
        throw err
      })
  },
  generateReceiptOfDischarge(orderId) {
    return apiClient
      .get('orders/' + orderId + '/receipt-of-discharge', {
        responseType: 'blob'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        if (
          err.request.responseType === 'blob' &&
          err.response.data instanceof Blob &&
          err.response.data.type &&
          err.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
          return new Promise((resolve, reject) => {
            let reader = new FileReader()
            reader.onload = () => {
              err.response.data = JSON.parse(reader.result)
              resolve(Promise.reject(err))
            }

            reader.onerror = () => {
              reject(err)
            }

            reader.readAsText(err.response.data)
          })
        }
        throw err
      })
  },
  generateCleanRefund(orderId) {
    return apiClient
      .get('orders/' + orderId + '/clean-refund', {
        responseType: 'blob'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        if (
          err.request.responseType === 'blob' &&
          err.response.data instanceof Blob &&
          err.response.data.type &&
          err.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
          return new Promise((resolve, reject) => {
            let reader = new FileReader()
            reader.onload = () => {
              err.response.data = JSON.parse(reader.result)
              resolve(Promise.reject(err))
            }

            reader.onerror = () => {
              reject(err)
            }

            reader.readAsText(err.response.data)
          })
        }
        throw err
      })
  },
  generateFarmerTransportationPdf(orderId) {
    return apiClient
      .get('orders/' + orderId + '/farmer-transportation-document', {
        responseType: 'blob'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        if (
          err.request.responseType === 'blob' &&
          err.response.data instanceof Blob &&
          err.response.data.type &&
          err.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
          return new Promise((resolve, reject) => {
            let reader = new FileReader()
            reader.onload = () => {
              err.response.data = JSON.parse(reader.result)
              resolve(Promise.reject(err))
            }

            reader.onerror = () => {
              reject(err)
            }

            reader.readAsText(err.response.data)
          })
        }
        throw err
      })
  },
  generateIncomeProtectedSaleContract(orderId) {
    return apiClient
      .get('orders/' + orderId + '/farmer-crop-equivalent-contract', {
        responseType: 'blob'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        if (
          err.request.responseType === 'blob' &&
          err.response.data instanceof Blob &&
          err.response.data.type &&
          err.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
          return new Promise((resolve, reject) => {
            let reader = new FileReader()
            reader.onload = () => {
              err.response.data = JSON.parse(reader.result)
              resolve(Promise.reject(err))
            }

            reader.onerror = () => {
              reject(err)
            }

            reader.readAsText(err.response.data)
          })
        }
        throw err
      })
  },
  downloadScannedIncomeProtectedSaleContract(orderId) {
    return apiClient
      .get('orders/' + orderId + '/scanned-income-protected-sale', {
        responseType: 'blob'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        if (
          err.request.responseType === 'blob' &&
          err.response.data instanceof Blob &&
          err.response.data.type &&
          err.response.data.type.toLowerCase().indexOf('json') != -1
        ) {
          return new Promise((resolve, reject) => {
            let reader = new FileReader()
            reader.onload = () => {
              err.response.data = JSON.parse(reader.result)
              resolve(Promise.reject(err))
            }

            reader.onerror = () => {
              reject(err)
            }

            reader.readAsText(err.response.data)
          })
        }
        throw err
      })
  },
  viewInvoice(orderId) {
    return apiClient
      .get('orders/' + orderId + '/public-invoice', {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewSupplementaryInvoice(orderId) {
    return apiClient
      .get('orders/' + orderId + '/supplementary-invoice', {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewReversalInvoice(orderId) {
    return apiClient
      .get('orders/' + orderId + '/reversal-invoice', {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewLateFeeInvoice(orderId) {
    return apiClient
      .get('orders/' + orderId + '/late-fee-invoice', {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewPromissoryNote(orderId) {
    return apiClient
      .get('orders/' + orderId + '/public-promissory-note', {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewPaymentNotice(orderId) {
    return apiClient
      .get('orders/' + orderId + '/public-payment-notice', {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewScannedPromissoryNote(orderId, versionId = null) {
    return apiClient
      .get('orders/' + orderId + '/public-scanned-promissory-note', {
        params: { version_id: versionId },
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewSalesContract(orderId) {
    return apiClient
      .get('orders/' + orderId + '/public-sales-contract', {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewTransportationDocument(orderId) {
    return apiClient
      .get('orders/' + orderId + '/public-transportation-document', {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewRepaymentSchedule(orderId) {
    return apiClient
      .get(`orders/${orderId}/public-repayment-schedule`, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewCreditAgreement(orderId) {
    return apiClient
      .get(`orders/${orderId}/public-credit-agreement`, {
        responseType: 'arraybuffer'
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewOrderReceipt(orderId) {
    return apiClient
      .get('orders/' + orderId + '/public-order-receipt', {
        responseType: 'arraybuffer'
      })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  exportCollections(query) {
    return apiClient
      .get('orders/export-collections', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportAdministrativeProceedingCalls(query) {
    return apiClient
      .get('orders/export-administrative-proceeding-calls', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportKit(query, kit) {
    return apiClient
      .post('orders/export-kit?' + query, {
        export_kit: kit
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportOrders(query) {
    return apiClient
      .get('orders/export-orders', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  destroy(id, params) {
    return apiClient
      .delete('orders/' + id, {
        data: params
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFinancingBankActivities(id) {
    return apiClient
      .get('orders/' + id + '/financing-bank-activities')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveRetailerInvoiceNumber(id, invoiceNumber, invoiceDate) {
    return apiClient
      .patch('orders/' + id + '/save-retailer-invoice-number', {
        invoice_number: invoiceNumber,
        invoice_date: invoiceDate
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  removeScannedPromissoryNote(orderId) {
    return apiClient
      .get('orders/' + orderId + '/remove-scanned-promissory-note')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  removeScannedIncomeProtectedSaleContract(orderId) {
    return apiClient
      .delete('orders/' + orderId + '/remove-scanned-income-protected-sale-contract')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendPaymentReminderSms(orderId) {
    return apiClient
      .post('orders/' + orderId + '/send-reminder-sms')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startImportRetailerInvoiceInfoProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('/orders/actions/import-retailer-invoice-info', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startImportOrderLegalProceedingInfoProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('/orders/actions/import-order-legal-proceeding-info', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startImportLegalProceedingOrdersProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('/orders/actions/import-legal-proceeding-orders', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  startImportGtsProductsProcess(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('/orders/actions/import-gts-products', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  toggleBlockingRetailerOrderPayment(id) {
    return apiClient
      .patch('orders/' + id + '/toggle-blocking-retailer-order-payment')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getWorkflowJobAnswers(orderId, workflowId) {
    return apiClient
      .get('orders/' + orderId + '/workflow-jobs/' + workflowId + '/answers')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFarmerPaymentInformation(orderId) {
    return apiClient
      .get('orders/' + orderId + '/get-payment-information')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPaymentInfoByDate(orderId, date, excluded_items) {
    return apiClient
      .get('orders/' + orderId + '/get-payment-info-by-date', {
        params: {
          date,
          excluded_items
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createTransaction(orderId, data) {
    return apiClient
      .post(`orders/${orderId}/transactions`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createManualTransaction(orderId, data) {
    return apiClient
      .post(`orders/${orderId}/transactions/pay-manually`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  updateBulutTahsilatBankPaymentId(orderId, transactionId, data) {
    return apiClient
      .patch(`orders/${orderId}/transactions/${transactionId}/update-bulut-tahsilat-bank-payment-id`, data)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPaymentPromises(orderId) {
    return apiClient
      .get('orders/' + orderId + '/payment-promises')
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  deletePaymentPromise(orderId, paymentPromiseId) {
    return apiClient
      .delete('orders/' + orderId + '/payment-promises/' + paymentPromiseId)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  updateAccountCollectionOrder(orderId, value) {
    return apiClient
      .patch(`orders/${orderId}/update-account-collection-order`, value)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  sendPaymentLink(orderId) {
    return apiClient
      .post(`orders/${orderId}/send-credit-card-payment-link`)
      .then(response => response)
      .catch(err => {
        throw err
      })
  },
  async viewMortgageContractItemDocument(itemId) {
    return apiClient.get(`mortgage-contract-items/${itemId}/view-document`, {
      responseType: 'arraybuffer'
    })
  },
  async downloadMortgageContractItemDocument(itemId) {
    return apiClient.get(`mortgage-contract-items/${itemId}/download`, {
      responseType: 'blob'
    })
  },
  async getTransactionHistory(orderId) {
    return apiClient.get(`orders/${orderId}/get-transaction-history`)
  }
}
